<app-header4></app-header4>
<div class="page-title-area page-title-area2">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN POLYSCIENCE</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">DEPARTEMENT DES SCIENCES <br>TECHNIQUES ET DE GESTION</h1>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="services-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration=".1s" data-wow-delay=".3s">
                <div class="single-services text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/genieInfo2.jpg" alt="">
                    <h4 class="title c-titleCard">GENIE INFORMATIQUE</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence en Informatique et<br>Réseaux Industriels</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence en Statistique <br> et Informatique <br> Décisionnelle</a></li>
                    </ul>
                    <a class="mainVoir" (click)="scrollToElement(genieInfo)">Voir plus</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration=".5s" data-wow-delay=".4s">
                <div class="single-services single-services-2 text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/genieElec2.jpg" alt="">
                    <h4 class="title c-titleCard">GENIE ELECTRIQUE</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>B.T.S Electromécanique</a></li>
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Electromécanique</a></li>
                        <br>
                        <br>
                        <br>
                    </ul>
                    <a class="mainVoir" (click)="scrollToElement(genieElec)">Voir plus</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-8 wow fadeInUp paddCard" data-wow-duration="1s" data-wow-delay=".5s">
                <div class="single-services single-services-3 text-center mt-30 c-marge">
                    <img src="assets/images/imagesAssets/gestion.jpg" alt="">
                    <h4 class="title c-titleCard">GESTION</h4>
                    <hr class="c-hr">
                    <ul class="list-group">
                        <li><a class="c-Text"><i class="fas fa-check-circle mr-10 c-icon"></i>Licence Gestion et Administration <br> des Biens</a></li>
                        <br>
                        <br>
                        <br>
                    </ul>
                    <a class="mainVoir" (click)="admissionMaster('GestionAdministrationBien')">Voir plus</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="choose-area mtopp" id="genieInfo" #genieInfo>
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="section-title">
                    <span class="science">SCIENCES TECHNIQUES </span>
                    <h3 class="title c-genieTitre">GENIE INFORMATIQUE</h3>
                </div>
                <div class="choose-cat">
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration=".5s" data-wow-delay=".4s" (click)="admissionMaster('InformatiqueReseauxIndustriel')">
                        <h4 class="title c-licence">LICENCE EN INFORMATIQUE ET RÉSEAUX INDUSTRIELS</h4>
                        <!-- <p>Many aspects of computing and technology and the term is more recognizable than before.</p> -->
                        <i class="fal fa-check c-check"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1s" data-wow-delay=".6s" (click)="admissionMaster('LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE')">
                        <h4 class="title c-licence">LICENCE EN STATISTIQUE ET INFORMATIQUE DÉCISIONNELLE</h4>
                        <!-- <p>Many aspects of computing and technology and the term is more recognizable than before.</p> -->
                        <i class="fal fa-check c-check"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay=".8s">
                        <!-- <h4 class="title">Information Technology</h4>
                        <p>Many aspects of computing and technology and the term is more recognizable than before.</p>
                        <i class="fal fa-check"></i> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="choose-thumb-area mt-30">
                    <div class="choose-thumb-1 choose-thumb-2">
                        <img class="item-1" src="assets/images/imagesAssets/tech1.jpg" alt="">
                    </div>
                    <!-- <div class="choose-thumb-2">
                        <img class="item-2" src="assets/images/imagesAssets/tech1.jpg" alt="">
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="choose-video-thumb">
                    <img src="assets/images/imagesAssets/infoV4.jpg" alt="">
                    <a href="#"><i class="fal fa-play"></i></a>
                </div>
            </div>
        </div> -->
    </div>
</div>




<!-- GENIE BIOLOGIQUE section  -->
<div class="about-experience-area pb-120" id="genieElec" #genieElec>
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="experience-item">
                    <span class="c-de">SCIENCES TECHNIQUES</span>
                    <h2 class="title c-biolo">GENIE ELECTRIQUE.</h2>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1">
                <div class="experience-item">
                    <p class="c-TexteBio">
                        L’ingénieur en génie électrique conçoit et développe les réseaux électriques, ainsi que les équipements associés. Il travaille principalement auprès des fournisseurs d’énergie, mais aussi dans des entreprises industrielles, du transport ou du BTP.
                    </p>
                    <!-- <a routerLink='/about'>Read More</a> -->
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".2s">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/electroRe.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title">B.T.S ELECTROMÉCANIQUE</h5>
                        <p>Cette formation a pour objectif de former des spécialistes dans la conception et la maintenance d'appareils électromécaniques.</p>
                        <a routerLink='/service-detail'>Voir Plus</a>
                        <i class="fas fa-vial"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-8 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".4s">
                <div class="single-experience mt-30">
                    <img src="assets/images/imagesAssets/elecmeRe.jpg" alt="">
                    <div class="experience-overlay">
                        <h5 class="title">LICENCE ELECTROMÉCANIQUE</h5>
                        <p>La Licence Électromécanique forme des collaborateurs spécialisés en amélioration des systèmes industriels.</p>
                        <a routerLink='/service-detail'>Voir Plus</a>
                        <i class="fas fa-microscope"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- GENIE BIOLOGIQUE section -->








<div class="choose-area mtopp">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="section-title">
                    <span class="science">DEPARTEMENT DES SCIENCES DE GESTION </span>
                    <h3 class="title c-genieTitre">GESTION</h3>
                </div>
                <div class="choose-cat">
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration=".5s" data-wow-delay=".4s" (click)="admissionMaster('GestionAdministrationBien')">
                        <h4 class="title c-licence2">LICENCE GESTION ET ADMINISTRATION DES BIENS</h4>
                        <p>L’objectif de cette licence est d’assurer la formation des administrateurs de biens du secteur privé au sens larges : agent immobilier, gestionnaire locatif et syndic. Ce professionnel vend ou gère des biens immobiliers en copropriété...</p>
                        <i class="fal fa-check c-check"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".6s">
                        <!-- <h4 class="title c-licence">LICENCE EN STATISTIQUE ET INFORMATIQUE DÉCISIONNELLE</h4>
                        <p>Many aspects of computing and technology and the term is more recognizable than before.</p>
                        <i class="fal fa-check c-check"></i> -->
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay=".8s">
                        <!-- <h4 class="title">Information Technology</h4>
                        <p>Many aspects of computing and technology and the term is more recognizable than before.</p>
                        <i class="fal fa-check"></i> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="choose-thumb-area">
                    <div class="choose-thumb-1 choose-thumb-2">
                        <img class="item-1" src="assets/images/imagesAssets/gestionRe.jpg" alt="">
                    </div>
                    <!-- <div class="choose-thumb-2">
                        <img class="item-2" src="assets/images/imagesAssets/tech1.jpg" alt="">
                    </div> -->
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-12">
                <div class="choose-video-thumb">
                    <img src="assets/images/imagesAssets/infoV4.jpg" alt="">
                    <a href="#"><i class="fal fa-play"></i></a>
                </div>
            </div>
        </div> -->
    </div>
</div>

<app-footer2></app-footer2>
